module.exports = __webpack_public_path__ + "img/TREASURY.f5faaadc.svg";